import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import './facts.scss';
import { GatsbyImage } from "gatsby-plugin-image";

export default ({ field_facts, field_facts_image, ...rest }) => {
  const image = (
    <Col xs={12} md={6}>
      {field_facts_image.relationships.field_media_image.localFile
        .childImageSharp && (
        <GatsbyImage
          image={field_facts_image.relationships.field_media_image
            .localFile.childImageSharp.gatsbyImageData}
          imgStyle={{ objectFit: 'cover' }}
          alt={field_facts_image.field_media_image.alt} />
      )}
      {!field_facts_image.relationships.field_media_image.localFile
        .childImageSharp && <p> SVG not supported in this zone! </p>}
    </Col>
  );

  const list = (
    <Col xs={12} md={6}>
      <h3>Fast Facts</h3>
      <div
        dangerouslySetInnerHTML={{
          __html: field_facts.field_html.processed,
        }}
      />
    </Col>
  );

  return (
    <section {...rest}>
      <Container>
        <Row>
          {image}
          {list}
        </Row>
      </Container>
    </section>
  );
};
